import { render, staticRenderFns } from "./certList.vue?vue&type=template&id=12c324fd&scoped=true&"
import script from "./certList.vue?vue&type=script&lang=js&"
export * from "./certList.vue?vue&type=script&lang=js&"
import style0 from "./certList.vue?vue&type=style&index=0&id=12c324fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c324fd",
  null
  
)

export default component.exports